function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useContext } from 'react';
import styles from './MenuItem.module.scss';
import cs from 'classnames';
import ThemeContext from '../../ThemeContext';
import { MenuContext } from '../Menu/Menu';
function MenuItem(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className,
    children = _ref.children,
    forwardedRef = _ref.forwardedRef,
    onClick = _ref.onClick,
    _ref$closeOnClick = _ref.closeOnClick,
    closeOnClick = _ref$closeOnClick === void 0 ? true : _ref$closeOnClick,
    props = _objectWithoutProperties(_ref, ["disabled", "className", "children", "forwardedRef", "onClick", "closeOnClick"]);
  var theme = useContext(ThemeContext);
  var closeMenu = useContext(MenuContext);
  function handleClick(e) {
    if (!disabled && typeof onClick === 'function') {
      e.currentTarget.focus();
      onClick(e);
      if (closeOnClick && typeof closeMenu === 'function') {
        closeMenu();
      }
    } else {
      e.preventDefault();
    }
  }
  return /*#__PURE__*/React.createElement("button", Object.assign({}, props, {
    ref: forwardedRef,
    type: "button",
    role: "menuitem",
    tabIndex: -1,
    "aria-disabled": disabled,
    className: cs(styles.button, styles["button--".concat(theme)], _defineProperty({}, String(className), className)),
    onClick: handleClick
  }), children);
}
export default forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({}, props, {
    forwardedRef: ref
  }));
});